import React, {useEffect, useState} from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import {TextBoxDataMart} from "./TextBoxDataMart";
import {FxmsData} from "../../../datas/FxData";
import {TextBox_CemsDash001DataMart} from "./TextBox_CemsDash001DataMart";

export const TextBox_CemsDash001 = (props) => {

    const [background, setBackground] = React.useState([]);
    const [open, setOpen] = useState(false)
    const [multi, setMulti] = useState(false)
    const [api, setApi] = useState('')
    const [designOptions, setDesignOptions] = useState({
        title:'title',bgColor:"#2a2929",fontSize:30,titleColor:'#ffffff',titleAlign:'left',
        content2:'55',content2Size:44,content2Color:'#ffffff',content2Align:'right',icon2:'CEMS.MainDashboardElectricicon.png',
        content1:"44",content1Align:'right',content1Size:44,content1Color:'#ffffff',icon1:'CEMS.MainDashboardFacilityIcon.png'
    })
    useEffect(()=>{
        if(props.item.fxUiDashbItemAttrs){
            if(props.item.fxUiDashbItemAttrs.length > 0) {
                let newOptions = {}
                for(let key in designOptions){
                    newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal
                }
                if(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=="api").attrVal != ''){
                    setApi(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=="api").attrVal)
                }
                setDesignOptions(newOptions)
            }
        }
    },[])

    useEffect(()=>{
        if(api != ""){
            FxmsData.GET(api).then(res=>{
                console.log(res.data)
                setDesignOptions({...designOptions,content:res.data.content})
            })
        }
    },[api])

    const saveCurrentData = () => {
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'api',attrVal:api,attrType:'string'})
        for(let key in designOptions){
            currentData.push({uiNo:props.item.uiNo,attrName:key,attrVal:designOptions[key]+'',attrType:'string'})
        }
        props.save(currentData,props.item.uiNo,props.item.opId)
    }

    return (
        <StyledEngineProvider>
            <div style={{backgroundColor:designOptions.bgColor,height:'inherit'}}>
                {props.editable ? <TextBox_CemsDash001DataMart options={{designOptions,setDesignOptions}} api={setApi} handleCloseAndSave={saveCurrentData}/>: ''}
                <div style={{margin:'10px',fontSize:designOptions.fontSize+'px',color:designOptions.titleColor,textAlign:designOptions.titleAlign}}>{designOptions.title}</div>
                <div style={{display:'flex'}}>
                    <div style={{flex:1,margin:'10px',fontSize:designOptions.content1Size+'px',color:designOptions.content1Color,textAlign:designOptions.content1Align}}><img style={{margin:'10px'}} src={designOptions.icon1}/>{designOptions.content1}</div>
                    <div style={{flex:1,margin:'10px',fontSize:designOptions.content2Size+'px',color:designOptions.content2Color,textAlign:designOptions.content2Align}}><img style={{margin:'10px'}} src={designOptions.icon2}/>{designOptions.content2}</div>
                </div>
            </div>

        </StyledEngineProvider>
    )
}